import { DatePickerProps } from 'antd/es/date-picker';
import { DatePicker } from 'antd';
import React, { useEffect, useRef } from 'react';

export const DatePickerAutoAccept: React.FC<DatePickerProps> = (props: DatePickerProps) => {
    const pickerRef = useRef<any>(null);

    useEffect(() => {
        const input = pickerRef.current?.nativeElement?.querySelector('input');
        if (!input) return;

        const handleInput = (): void => {
            const date = input.value.replaceAll('.', '');
            if (date.length !== 8 || isNaN(date)) return;

            const formattedDate = `${date.slice(0, 2)}.${date.slice(2, 4)}.${date.slice(4)}`;
            Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set?.call(
                input,
                formattedDate
            );
            input.blur();
        };

        input.addEventListener('input', handleInput);
        return () => input.removeEventListener('input', handleInput);
    }, []);

    return <DatePicker {...props} ref={pickerRef} />;
};
